import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectViewStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      marginBottom: 16,
      [theme.breakpoints.down(960)]: {
        maxWidth: 'initial'
      }
    },

    header: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 35,
      alignItems: 'center',
      [theme.breakpoints.down(960)]: {
        marginBottom: 20,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        gap: 15
      }
    },

    projectName: {
      marginRight: 'auto',
      maxWidth: 848,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',

      [theme.breakpoints.down('sm')]: {
        display: '-webkit-box',
        lineClamp: 3,
        boxOrient: 'vertical',
        whiteSpace: 'normal'
      }
    },

    button: {
      zIndex: 2,
      marginLeft: theme.spacing(2),
      minWidth: 250,
      [theme.breakpoints.down(960)]: {
        marginLeft: 0,
        minWidth: 142,
        fontSize: 12,
        padding: 5
      }
    },

    contact: {
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%'
      }
    },

    price: {
      fontWeight: 600
    },

    mainProjectInfo: {
      display: 'flex',
      margin: '0 0 30px 0',

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        margin: theme.spacing(2, -2)
      }
    },

    img: {
      objectFit: 'cover',
      width: '100%',
      flexShrink: 0,
      minHeight: 263,
      cursor: 'pointer',

      [theme.breakpoints.up('md')]: {
        marginRight: theme.spacing(2),
        width: 450,
        maxHeight: 448
      }
    },

    imgIcon: {
      backgroundColor: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 200
    },

    aboutProject: {
      width: '100%',
      marginTop: theme.spacing(2),

      [theme.breakpoints.up('md')]: {
        marginTop: 0
      }
    },

    row: {
      display: 'flex',
      width: '100%',
      padding: theme.spacing(1, 2),
      alignItems: 'center',

      '&:nth-child(even)': {
        backgroundColor: '#fff'
      }
    },

    title: {
      width: 170,
      marginRight: theme.spacing(2),
      flexShrink: 0
    },

    tabPanel: {
      padding: theme.spacing(3, 0)
    },

    tabFlexContainer: {
      flexWrap: 'wrap'
    },

    noneIndicator: {
      display: 'none'
    },

    tab: {
      position: 'relative',

      '&:before': {
        position: 'absolute',
        height: 2,
        content: '""',
        bottom: 0,
        width: '100%',
        opacity: 0,

        backgroundColor: theme.palette.secondary.main
      }
    },

    tabActive: {
      '&:before': {
        opacity: 1,
        transition: theme.transitions.create('opacity', {
          easing: 'linear'
        })
      }
    },

    sup: {
      alignSelf: 'flex-end'
    },

    textWhiteSpace: {
      whiteSpace: 'pre-wrap'
    },

    wordBreak: {
      wordBreak: 'break-word'
    },

    imageList: {
      display: 'grid',
      gridRowGap: theme.spacing(2),
      gridColumnGap: theme.spacing(2),
      gridTemplateColumns: 'repeat(auto-fill, minmax(335px, 1fr))'
    },

    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      cursor: 'pointer'
    },

    favoritBtn: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 30,
      [theme.breakpoints.down(1280)]: {
        position: 'fixed',
        marginRight: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'white',
        width: '100%',
        height: 75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.25)',
        zIndex: 1000
      }
    }
  })
)
